import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacilityListAction,
  getProviderProfileDetailAction,
  getTestDetailNewPopupActionIBU,
  getTestDetailUpdatePopupActionIBU,
} from "../../../redux/actions/ProviderProfileDetailAction";
import Modal from "react-modal";
import { ConfirmationTestPopupIBU } from "./ConfirmationTestPopupIBU";
import { getTagListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import CustomPagination from "../../../common/CustomPagination";

export const TestDetailsPopupIBU = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {

  const dispatch = useDispatch();
  const [isApproveReject, setIsApproveReject] = useState(null);
  const [newSearchFilterTest, setNewSearchFilterTest] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "A",
  });
  const [updateSearchFilterTest, setUpdateSearchFilterTest] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "U",
  });
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );



  useEffect(() => {
    dispatch(getTestDetailNewPopupActionIBU(newSearchFilterTest));
    dispatch(getTestDetailUpdatePopupActionIBU(updateSearchFilterTest));
    dispatch(getFacilityListAction("TEST", rowData?.providerID));
    dispatch(getTagListNetworkAction());
  }, []);

  const handleClose = () => {
    dispatch(getProviderProfileDetailAction({ ...searchFilter, ...apiParams }));
    setRowData(null);
  };

  console.log("rowdatedetais",providerPortalDetailReducer?.getTestDetailNewPageIBU?.skuDetails)

  return (
    <>
      <div className="modal-body" style={{ height: "100%" }}>
        <div className="back-buttondiv" onClick={handleClose}>
          <i className="fa-solid fa-circle-arrow-left"></i>
          <h6 style={{ cursor: "pointer" }}>Back</h6>
        </div>
        <div>
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            Test Details ({rowData?.providerName})
          </h4>
        </div>
        {providerPortalDetailReducer?.getTestDetailNewPageIBU?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">New Tests</h5>
            </div>
            <div className="table-responsive __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr className="avanishtbl">
                    <th>Test ID </th>
                    <th>Test Name </th>
                    <th>Client Name </th>
                    <th>Rate</th>
                    <th>Existing Rate</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Doc Type</th>
                    <th>View Doc</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getTestDetailNewPageIBU?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.testId}</td>                          
                          <td>{ele?.diagnosticTest}</td>
                          <td>{ele?.clientName}</td>
                          <td>{ele?.rate}</td>
                          <td>{ele?.existingRate}</td>
                          <td>{ele?.startDate?.split("T")[0]}</td>
                          <td>{ele?.endDate?.split("T")[0]}</td>
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td>{ele?.docType}</td>
                          <td> 
                              <a
                                href={ele?.imageUrl}
                                target="blank"
                                className="text-decoration"
                              >
                                View
                              </a>
                           
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({ ...ele, index: index });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getTestDetailNewPageIBU
                  ?.totalRow !== 0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getTestDetailNewPageIBU
                        ?.totalRow
                    }
                    perPageData={newSearchFilterTest?.rows}
                    searchFilter={newSearchFilterTest}
                    setSearchFilter={setNewSearchFilterTest}
                    apiCall={getTestDetailNewPopupActionIBU}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
        {providerPortalDetailReducer?.getTestDetailUpdatePageIBU?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">Existing Tests</h5>
            </div>
            <div className="table-responsive __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr className="avanishtbl">
                    <th>Test ID </th>
                    <th>Test Name </th>
                    <th>Client Name </th>
                    <th>Rate</th>
                    <th>Existing Rate</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Doc Type</th>
                    <th>View Doc</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getTestDetailUpdatePageIBU?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.testId}</td>
                          <td>{ele?.diagnosticTest}</td>
                          <td>{ele?.clientName}</td>
                          <td>{ele?.rate}</td>
                          <td>{ele?.existingRate}</td>
                          <td>{ele?.startDate?.split("T")[0]}</td>
                          <td>{ele?.endDate?.split("T")[0]}</td>
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td>{ele?.docType}</td>
                          <td> 
                              <a
                                href={ele?.imageUrl}
                                target="blank"
                                className="text-decoration"
                              >
                                View
                              </a>
                           
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({ ...ele, index: index });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getTestDetailUpdatePageIBU
                  ?.totalRow !== 0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getTestDetailUpdatePageIBU
                        ?.totalRow
                    }
                    perPageData={updateSearchFilterTest?.rows}
                    searchFilter={updateSearchFilterTest}
                    setSearchFilter={setUpdateSearchFilterTest}
                    apiCall={getTestDetailUpdatePopupActionIBU}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        isOpen={isApproveReject}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ConfirmationTestPopupIBU
          isApproveReject={isApproveReject}
          setIsApproveReject={setIsApproveReject}
          rowData={rowData}
          handleClose={handleClose}
          newSearchFilterTest={newSearchFilterTest}
          updateSearchFilterTest={updateSearchFilterTest}
        />
      </Modal>
    </>
  );
};
